import { Bonus } from "@/manager/product/models/bonus.model";
import { Pack } from "@/manager/product/models/pack.model";
import { DelegationInterface } from "@/shared/interfaces/delegation.interface";

export enum TypeOfProduct {
  Conference = 1,
  Course = 2,
  Event = 3,
  Book = 4,
  Merchandising = 5,
  Token = 6,
  Pack = 7,
}

export enum TypeOfPrice {
  Bono=0,
  Conference=1,
  Course=2,
  Web=3,
  Base=4,
  Repeat=5,
  Price1=6,
  Price2=7,
  Price3=8,
  Price4=9,
  Price5=10,
  Fusion=11,
  Webinar=12,
  Tlp=13,
  Pwp=14,
  PPago=15,
  Shuttle=16,
  Ambassador=17,
  Cn3=18
}

export const TypeOfPriceLiteral = [
  "bono",
  "conference",
  "course",
  "web",
  "base",
  "repeat",
  "price1",
  "price2",
  "price3",
  "price4",
  "price5",
  "fusion",
  "webinar",
  "tlp",
  "pwp",
  "pPago",
  "shuttle",
  "ambassador",
  "cn3"
];
export const TypeOfPriceBackLiteral = [
  "useBonoPrice",
  "useConferencePrice",
  "useCoursePrice",
  "useWebPrice",
  "useBasePrice",
  "useRepeatPrice",
  "usePrice1",
  "usePrice2",
  "usePrice3",
  "usePrice4",
  "usePrice5",
  'useFusion',
  'useWebinar',
  'useTlp',
  'usePwp',
  'usePPago',
  'useShuttle',
  'useAmbassador',
  'useCn3'
];

export const TypeOfProductLiteral = [
  "Sin indicar",
  "Conferencia",
  "Curso",
  "Evento",
  "Libro",
  "Merchandising",
  "Bono",
  "Pack"
];

export enum Branch {
  Leadership = 1,
  Business = 2,
}

export interface ProductInterface {
  id?: string;
  name: string;
  acronym?: string;
  level: number;
  daysOfDuration?: number;
  typeOfProduct: TypeOfProduct;
  descripcion?: string;
  formativeBranch?: Branch;
  pack?: Pack;
  isBudgetable?: boolean;
  onlyTeachDelegation?: DelegationInterface[];
}

export interface Pricing {
  base?: number;
  byHour?: number;
  conference?: number;
  course?: number;
  reEnroll?: number;
  reserve?: number;
  repeat?: number;
  tax?: number;
  bono?: number;
  discountSoonPayment?: number;
  fusion?: number;
  webinar?: number;
  tlp?: number;
  pwp?: number;
  pPago?: number;
  shuttle?: number;
  ambassador?: number;
  cn3?: number;
}

export class Product implements ProductInterface, Pricing {
  public id?: string;
  public name: string;
  public acronym?: string;
  public bonus?: Bonus[];
  public pack?: Pack;
  public level: number;
  public daysOfDuration?: number;
  public typeOfProduct: TypeOfProduct;
  public descripcion?: string;
  public formativeBranch?: Branch;
  public base?: number;
  public web?: number;
  public byHour?: number;
  public conference?: number;
  public course?: number;
  public reEnroll?: number;
  public reserve?: number;
  public repeat?: number;
  public tax?: number;
  public isBudgetable?: boolean;
  public discountSoonPayment?: number;
  public onlyTeachDelegation?: DelegationInterface[];
  public fusion?: number;
  public webinar?: number;
  public tlp?: number;
  public pwp?: number;
  public pPago?: number;
  public shuttle?: number;
  public ambassador?: number;
  public cn3?: number;

  constructor() {
    this.name = "";
    this.level = 1;
    this.typeOfProduct = TypeOfProduct.Course;
  }

  public title() {
    let title = "Sin título";
    if (this.typeOfProduct === TypeOfProduct.Course) {
      if (this.level && this.formativeBranch) {
        title = `Nivel ${this.level}`;
      } else if (this.acronym && this.acronym.includes("TLP")) {
        title = "TLP";
      } else if (!this.formativeBranch) {
        title = "Especialización";
      }
    } else if (this.typeOfProduct === TypeOfProduct.Book) {
      title = "Libro";
    } else if (this.typeOfProduct && TypeOfProduct.Merchandising) {
      title = "Merchandising";
    }
    return title;
  }
}
